<template>
	  <img v-lazy="fullPath" :alt="alt" :class="customClass" class="base-image" v-if="source" />
</template>

<script>
export default {
  name: "BaseImage",
  props: {
    source: {
      type: String,
      required: false
    },
    alt: {
      type: String,
      required: false
    },
    customClass: {
      type: String,
      required: false
    },
    externalImage: {
      type: Boolean,
      required: false,
      default: false
    },
    cloudFront: {
      type: String,
      required: false,
      default: ""
    },
    fitIn:{
      type: String,
      required: false,
      default: process.env.FIT_IN_WIDTH_DEFAULT
    }
  },
  computed: {
    fullPath() {
      if (this.source) {
        if (this.externalImage) {
          return this.source;
        } else {
          return this.getUrl()
        }
      } else {
        return "/static/img/default-user.png";
      }
    }
  },
  methods:{
    getExt(str){
      if(str){
        str = str.toLowerCase().split(".");
        return str[str.length - 1];
      }
      else{
        return null
      }
	  },
    getUrl() {
      let fitIn = ''

      if (this.fitIn) {
        fitIn = `${this.fitIn}/`
      }

      if (this.getExt(this.source) == 'svg' || this.getExt(this.source) == 'gif'){
        return `${process.env.CONTAINER_URL}${this.source}`;
      }

      return `${process.env.CDN_URL}${fitIn}${this.source}`;
    }
  }
};
</script>

<style scoped>
.img-galery[lazy=loading], .img-galery[lazy=error]{
  object-fit: none;
}
.base-image{
  transition: all 300ms;
}
.current div img {
  border: 2px solid var(--main-color);
}

</style>



// WEBPACK FOOTER //
// src/components/atoms/BaseImage.vue